export { default } from '@ui-kit/components/formComponents/Autocomplete/index.web'
